/*
 * fn: recentDate
 *
 * Gets the most recent date from a list
 *
 */
export const recentDate = (...dates: (string | undefined)[]) => {
  let recent: string | undefined
  let recentTime = -Infinity

  for (const date of dates) {
    if (date === undefined) continue
    const time = Date.parse(date)
    if (Number.isNaN(time) || time <= recentTime) continue
    recent = date
    recentTime = time
  }

  return recent
}
